import useStyleOptions from '/druid/useStyleOptions';

export default function useGroupTimestamp(): [boolean | number] {
  const [{ groupTimestamp }] = useStyleOptions();

  return [groupTimestamp];
}
